import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';

const useStyles = createUseStyles((theme: Theme) => {
    const { color, radius } = theme.custom;
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            gap: 8,
            padding: '48px 24px',
        },
        icon: {
            width: 44,
            height: 44,
            borderRadius: radius.md,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: color.surfaceMuted,
            color: color.text.secondary,
            marginBottom: 4,
            '& svg': { fontSize: 24 },
        },
        title: { margin: 0, fontSize: 15, fontWeight: 600, color: color.text.primary },
        hint: { margin: 0, fontSize: 13, color: color.text.secondary, maxWidth: 360, textWrap: 'pretty' },
        action: { marginTop: 8 },
    };
});

export interface EmptyStateProps {
    title: React.ReactNode;
    hint?: React.ReactNode;
    icon?: React.ReactNode;
    action?: React.ReactNode;
}

/** What a list shows instead of nothing: a title, why it is empty and (if possible) the way out. */
const EmptyState = ({ title, hint, icon, action }: EmptyStateProps) => {
    const classes = useStyles();
    return (
        <div className={classes.root} role="status">
            <div className={classes.icon} aria-hidden="true">{icon ?? <InboxOutlinedIcon />}</div>
            <p className={classes.title}>{title}</p>
            {hint && <p className={classes.hint}>{hint}</p>}
            {action && <div className={classes.action}>{action}</div>}
        </div>
    );
};

export default EmptyState;
